import { render } from "./OutlinedIcon.vue?vue&type=template&id=2fdb19f2"
import script from "./OutlinedIcon.vue?vue&type=script&lang=js"
export * from "./OutlinedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__